import React from "react";
import { useTranslation } from "react-i18next";


const Viewdetails = () => {
  const { t } = useTranslation();
  const leaveData = {
    studentName: "Mayank",
    fromDate: "08 Feb,25",
    toDate: "04 Feb,25",
    noOfDays: "1",
    reason: "test student leave",
    status: "canceled",
    type: "full-day",
    mode: "transportation-only",
  };

  return (
    <div className="leave-container">
      <h2 className="leave-title">{t("Leave")}</h2>
      <table className="leave-table">
        <tbody>
          <tr>
            <td>{t("Student Name")}</td>
            <td>{leaveData.studentName}</td>
          </tr>
          <tr>
            <td>{t("Leave From Date")}</td>
            <td>{leaveData.fromDate}</td>
          </tr>
          <tr>
            <td>{t("Leave To Date")}</td>
            <td>{leaveData.toDate}</td>
          </tr>
          <tr>
            <td>{t("No of Days")}</td>
            <td>{leaveData.noOfDays}</td>
          </tr>
          <tr>
            <td>{t("Leave Reason")}</td>
            <td>{leaveData.reason}</td>
          </tr>
          <tr>
            <td>{t("Leave Status")}</td>
            <td>{leaveData.status}</td>
          </tr>
          <tr>
            <td>{t("Leave Type")}</td>
            <td>{leaveData.type}</td>
          </tr>
          <tr>
            <td>{t("Leave Mode")}</td>
            <td>{leaveData.mode}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default Viewdetails;
